import type { WorksheetFormEntity } from '../../../worksheets/forms/entities';

import { StsBackendOperation } from '../../../sts-backend-operation';
import { toWorksheetFormEntity } from '../../../worksheets/forms/helpers';

/** Parameters for fetching an existing worksheet submission. */
export type FetchSubmissionParams = {
    /** The case number the submission belongs to. */
    caseNumber: string;

    /** The unique ID of the worksheet submission. */
    submissionId: string;
};

/**
 * Fetches an existing worksheet submission by case number and submission ID.
 * Returns the submitted answers and associated assets as a full worksheet form entity.
 */
export class FetchSubmission extends StsBackendOperation {
    /**
     * Fetch a worksheet submission by case number and submission ID.
     *
     * @param params - the case number and submission ID to look up
     * @returns the worksheet form entity with answers populated, or undefined if the fetch fails
     */
    async exec(params: FetchSubmissionParams): Promise<WorksheetFormEntity | undefined> {
        const response = await this.client.retrieveWorksheetSubmission(params);

        if (!response.success) {
            return undefined;
        }

        return toWorksheetFormEntity(response.data);
    }
}
